export default "__VITE_ASSET__Br2yMLts__"